import CopyButton from "@components/buttons/CopyButton";
import { MouseEvent, ReactNode } from "react";
import { displayText } from "./fintracFormat";

const copyableText = (value: unknown): string => {
  if (value === null || value === undefined) return "";
  return String(value).trim();
};

const stopRowNavigation = (event: MouseEvent) => {
  event.stopPropagation();
};

export const FintracCopyButton = ({
  value,
  message,
}: {
  value: unknown;
  message: string;
}) => {
  const copyText = copyableText(value);
  if (!copyText) return null;
  return (
    <span
      data-row-control="true"
      className="inline-flex shrink-0"
      onClick={stopRowNavigation}
      onMouseDown={stopRowNavigation}
    >
      <CopyButton
        copyText={copyText}
        copyMessage={message}
        buttonSize="14px"
        copyIconSize={12}
      />
    </span>
  );
};

export const FintracCopyValue = ({
  value,
  message,
  align = "start",
}: {
  value: unknown;
  message?: string;
  align?: "start" | "end";
}) => {
  const text = displayText(value);
  const end = align === "end";
  return (
    <div
      className={`flex h-full w-full min-w-0 items-center gap-1 ${
        end ? "justify-end" : "justify-start"
      }`}
    >
      <span
        className={`min-w-0 truncate ${end ? "text-right" : "flex-1"}`}
        title={text === "—" ? undefined : text}
      >
        {text}
      </span>
      {message ? <FintracCopyButton value={value} message={message} /> : null}
    </div>
  );
};

export const withFintracCopy = (
  value: unknown,
  message: string | undefined,
  content: ReactNode,
) => {
  const copyText = copyableText(value);
  if (!message || !copyText) return content;
  return (
    <div className="flex h-full w-full min-w-0 items-center gap-1">
      <div className="min-w-0 flex-1">{content}</div>
      <FintracCopyButton value={copyText} message={message} />
    </div>
  );
};
